import {injectable} from 'inversify';

import type {TenantModel} from './Tenant.model';

import {BaseController} from '../../../core/domain/Base/Base.controller';

@injectable()
export class TenantController extends BaseController<TenantModel> {
  constructor() {
    super();
  }
}
